export class WidgetWrapperEntity {
  #model
  #setValueInternal
  #getValueInternal

  /** 
   * @param { Function } getValue - получения value с которым работает виджет (Источник в датасоурс, property)
   * @param { Function } setValue - установка value (дата соурс, проперти)
   * @param { Object } model - модель текущего виджета, exmpl: { $ID: '123', $Type: 'dr-button', Caption: 'N' }
   */
  constructor({ getValue, setValue, model }) {
    this.#model = model
    
    /* Возможность через widgetsApi показывать всю модель виджета, и сразу изменить property этой модели
    * const widget = this.WidgetsApi()
    * widget.Caption = 'new_Caption'
    */
    Object.keys(model).forEach((propName) => {
      Object.defineProperty(this, propName, {
        get: () => this.getPropValue(propName),
        set: (value) => this.setPropValue(propName, value),
        enumerable: true
      })
    })
    this.#setValueInternal = setValue
    this.#getValueInternal = getValue
  }

  getPropValue(propName) {
    return this.#model[propName]
  }

  setPropValue(propName, value) {
    this.#model[propName] = value
  }

  getValue() {
    if (typeof this.#getValueInternal !== 'function') {
      return
    }
    return this.#getValueInternal()
  }

  setValue(val) {
    if (typeof this.#setValueInternal !== 'function') {
      return
    }
    this.#setValueInternal(val)
  }
}